import React from 'react';
import moment from 'moment';
import { useTheme } from '@mui/material/styles';

import { ThemeProps } from '@styles/theme';
import { messages } from 'AuthPart/DevicePairing/devicePairing.messages';

import { useStyles } from './PairDeviceModal.styles';

export type DeviceCardProps = {
    deviceName: string;
    devicePlatform: string;
    applicationVersion: string;
    requestIp: string;
    requestedAt: string;
};

/**
 * What is actually being paired. This is the whole reason approval is a second step: a code on
 * its own says nothing about who is asking, and a shoulder-surfed code would otherwise be enough.
 */
export const DeviceCard: React.FC<DeviceCardProps> = ({
    deviceName, devicePlatform, applicationVersion, requestIp, requestedAt,
}) => {
    const theme = useTheme<ThemeProps>();
    const styles = useStyles({ theme });

    const rows: Array<[string, string]> = [
        [messages['devicePairing.device.platform'], devicePlatform],
        [messages['devicePairing.device.version'], applicationVersion],
        [messages['devicePairing.device.ip'], requestIp],
        [messages['devicePairing.device.requestedAt'], requestedAt ? moment(requestedAt).format('LLL') : ''],
    ];

    return (
        <div className={styles.deviceCard} data-testid="pairing-device-card">
            <div className={styles.deviceName}>
                {deviceName || messages['devicePairing.device.unnamed']}
            </div>

            {
                rows
                    .filter(([, value]) => !!value)
                    .map(([label, value]) => (
                        <div className={styles.deviceRow} key={label}>
                            <span className={styles.deviceLabel}>{label}</span>
                            <span className={styles.deviceValue}>{value}</span>
                        </div>
                    ))
            }
        </div>
    );
}
